import { render } from "./EditProfileAndTypesComponent.vue?vue&type=template&id=4906be8a&scoped=true"
import script from "./EditProfileAndTypesComponent.vue?vue&type=script&lang=js"
export * from "./EditProfileAndTypesComponent.vue?vue&type=script&lang=js"

import "./EditProfileAndTypesComponent.vue?vue&type=style&index=0&id=4906be8a&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4906be8a"]])

export default __exports__